import { Locale } from '@synergy/models';
import { defaultLocale } from '@synergy/config';

export const currentLocaleReducer = (state: Locale = defaultLocale) => {
    return state;
};
